/**
 *
 * Public interface of ButtonCounter component
 *
 */

import ButtonCounter from './ButtonCounter';
import { SIZE } from './components/Container';

export { SIZE };
export default ButtonCounter;
